import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			HWError: null,
			loading: false
		}
	}
	checkHW = (e) => {
		if ((this.props.data.PatientHeight.length == 2 || this.props.data.PatientHeight.length == 3) && this.props.data.PatientWeight.length > 0 && parseInt(this.props.data.PatientWeight) != 0 && parseInt(this.props.data.PatientHeight) > 9 && this.props.data.PatientWeight.length < 4) {
			//R19
			if (this.props.data.InbornMetabolic) {
				//R25
				this.setState({ loading: true })
				fetch(window.location.origin + window.location.pathname + 'R25Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {

					if (response.status == 200) {
						var result = await response.text();
						if (result == "R26") {
							fetch(window.location.origin + window.location.pathname + 'R26Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
								this.setState({ loading: false })
								if (response.status == 200) {
									var PANumber = await response.text();
									if (PANumber) {
										this.props.setData('PANumber', PANumber)
										this.props.navigate("R28")
									} else {
										this.props.navigate("R26c")

									}
								} else {
									this.props.navigate("R26B")
								}
							})
						} else {
							this.setState({ loading: false })
							this.props.navigate(result)
						}
					} else {
						this.setState({ loading: false })
						this.setState({ HWError: "Unexpected Error has Occured" })
					}
				})
			} else {
				if (new Date().getTime() - new Date(this.props.data.DOB).getTime() > 94608000000) {
					//10 Years or older
					//R20
					this.setState({ loading: true })
					fetch(window.location.origin + window.location.pathname + 'BMI', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
						this.setState({ loading: false })
						if (response.status == 200) {
							console.log("Checking BMI")

							var BMILimit = await response.text();
							this.props.setData('BMI', (((parseInt(this.props.data.PatientWeight) / parseInt(this.props.data.PatientHeight)) / parseInt(this.props.data.PatientHeight)) * 703))
							var BMI = (((parseInt(this.props.data.PatientWeight) / parseInt(this.props.data.PatientHeight)) / parseInt(this.props.data.PatientHeight)) * 703)
							console.log("BMI: " + BMI)
							console.log("BMILimit: " + BMILimit)
							console.log("BMI > BMILimit: " + (parseFloat(BMI) > parseFloat(BMILimit)))
							if (parseFloat(BMI) > parseFloat(BMILimit)) {
								//Yes
								if (new Date().getTime() - new Date(this.props.data.DOB).getTime() < 662256000000) {
									//Younger then 21
									this.props.navigate('R13')
								} else {
									this.props.navigate('R14')
								}
							} else {
								//No
								if (parseInt(BMI) < 10) {
									this.setState({ HWError: "That is not a valid response" })
								} else {
									this.props.navigate('R21')
								}
							}
						} else {
							this.setState({ HWError: "Unexpected error has occured" })
						}
					})
				} else {
					//Younger then 10
					if (new Date().getTime() - new Date(this.props.data.DOB).getTime() < 31536000000) {
						//Younger then 1
						//R25
						this.setState({ loading: true })
						fetch(window.location.origin + window.location.pathname + 'R25Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
							if (response.status == 200) {
								var result = await response.text();
								if (result == "R26") {
									fetch(window.location.origin + window.location.pathname + 'R26Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
										this.setState({ loading: false })
										if (response.status == 200) {
											var PANumber = await response.text();
											if (PANumber) {
												this.props.setData('PANumber', PANumber)
												this.props.navigate("R28")
											} else {
												this.props.navigate("R26c")

											}
										} else {
											this.props.navigate("R26B")
										}
									})
								} else {
									this.setState({ loading: false })
									this.props.navigate(result)
								}
							} else {
								this.setState({ loading: false })
								this.setState({ HWError: "Unexpected error has occured" })
							}
						})
					} else {
						this.props.navigate('R21')
					}
				}
			}

		} else {
			this.setState({ HWError: 'Invalid response.' })
		}
	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Enter the patient’s height in inches:</p>
				<input type="number" value={this.props.data.PatientHeight} onChange={(e) => { this.props.setData('PatientHeight', e.currentTarget.value) }} />

				<br />

				<p>Enter the patient’s current weight in pounds.</p>
				<input type="number" value={this.props.data.PatientWeight} onChange={(e) => { this.props.setData('PatientWeight', e.currentTarget.value) }} />
				<br />
				{this.state.HWError ? <div className="error">{this.state.HWError}</div> : ''}
				{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={() => this.checkHW()}>Continue</div>}
			</div>
		);
	}
}